// extracted by mini-css-extract-plugin
export default {"wrapper":"wr-z","response":"xr-z","error":"yr-z","disabled":"zr-z","buttons":"Ar-z","feedbackQuestionSection":"Br-z","yesNoWrapper":"Cr-z"};